import { FC } from "react";
import { Select, MenuItem, Box, FormControl, createTheme, ThemeProvider } from "@mui/material";

interface ICountryItem {
    label: string;
    icon: string;
}

interface ICountriesSelectProps {
    onChange: (value: string) => void;
    selectedValue: string;
    countries: ICountryItem[];
}

const lightTheme = createTheme({
    palette: {
        mode: "light",
    },
});

// export const countriesMapping = {
//     USA: { label: "US", icon: "us" },
//     Canada: { label: "Canada", icon: "ca" },
//     Germany: { label: "Germany", icon: "de" },
//     Australia: { label: "Australia", icon: "au" },
//     Spain: { label: "Spain", icon: "es" },
//     Singapore: { label: "Singapore", icon: "sg" },
//     EuroZone: { label: "Euro Zone", icon: "eu" },
//     "Hong Kong": { label: "Hong Kong", icon: "hk" },
//     Japan: { label: "Japan", icon: "jp" },
//     Italy: { label: "Italy", icon: "it" },
//     France: { label: "France", icon: "fr" },
// };

export const CountrySelect: FC<ICountriesSelectProps> = ({ countries, onChange, selectedValue }) => {
    const CDN_FLAG_URL = "https://flagcdn.com/";

    const options = countries;

    return (
        <ThemeProvider theme={lightTheme}>
            <Box id="countrySelect">
                <FormControl fullWidth>
                    <Select
                        name="countrySelect"
                        value={selectedValue}
                        onChange={e => onChange(e.target.value)}
                        renderValue={selected => {
                            const selectedCountry = countries.find(c => c.label === selected);
                            return (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <img
                                        src={`${CDN_FLAG_URL}${selectedCountry?.icon || "us"}.svg`}
                                        width={20}
                                        height={20}
                                        alt="flag"
                                    />
                                </Box>
                            );
                        }}
                        sx={{
                            minWidth: "52px",
                            height: "28px",
                        }}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    transform: "translateX(-20px)",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                },
                            },
                        }}>
                        {options.map(option => (
                            <MenuItem
                                value={option.label}
                                sx={{ fontWeight: 700, fontSize: "10px", gap: "5px" }}
                                key={option.label}>
                                <img src={`${CDN_FLAG_URL}${option?.icon}.svg`} width={20} height={20} />
                                {option?.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </ThemeProvider>
    );
};
